import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SettingsService, AccountSettingsType } from '../../core';
import { ITransactionsCustomSectionsSettings } from '../models/transactions-custom-sections-settings';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class TransactionMenuSettingsResolver implements Resolve<any> {
	constructor(private _settingsService: SettingsService) { }

	resolve(): Observable<ITransactionsCustomSectionsSettings> {
		return this._settingsService.getSettings<ITransactionsCustomSectionsSettings>(AccountSettingsType.CustomSystemSectionsSettings)
			.pipe(map(s => {
				if (s) {
					return s;
				}
				return of(null);
			})).pipe(catchError(e => {
				return of(null);
			}));
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/resolvers/transaction-menu-settings.resolver.ts